module.exports = __webpack_public_path__ + "img/4.965457b0.webp";